export const sectionAccessor = id => `lifestyle.sections.${id}`;

export const labelAccessor = id => `lifestyle.labels.${id}`;

export const optionAccessor = id => `lifestyle.opts.${id}`;

export const valueExists = value => {
  if (value || value === 0) {
    if (typeof value === 'string' || Array.isArray(value)) return value.length > 0;
    return true;
  }
  return false;
};
